import {GameSvc} from '../services/game.service';
import {BettingSvc} from '../services/betting.service';

/**
 * Random bet validator
 * @module directives/future bet validator
 * @type {{update: (function(*, *))}}
 */

export const RandomBetValidator = {
    update(element, binding) {
        if (/[\d\.]+/i.test(element.value)) {
            let newValue = Number(element.value);
            if (newValue < 1 || newValue > GameSvc.getGameSvc().spotNumber) {
                newValue = '';
                BettingSvc.getBettingSvc().random = '';
            }

            element.value = newValue;
            binding.value = element.value;
        } else {
            let newValue = element.value.replace(/[a-zA-Z]+/ig, '');
            element.value = newValue;
            binding.value = element.value;
        }
    },
};



// WEBPACK FOOTER //
// randombet_validator.js